<!--
  lovi
  支付密码 2020-06-03
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :class="{ noShadow: title == '' }"
      :title="title"
      :fixed="true"
      left-arrow
      @click-left="navBarBack"
    />
    <div class="scroll-wrapper">
      <h3 v-if="flag == 'reg'">
        {{ confirmFlag ? $t("payPsd.ConfirmPayPsd") : $t("payPsd.SetPayPsd") }}
      </h3>
      <!-- 设置支付密码 -->
      <template>
        <template v-if="oldFlag">
          <van-password-input
            :gutter="10"
            :value="oldPsd"
            :focused="true"
            @focus="showKeyboard = true"
          />
          <p class="tips text-gray">
            {{
              parentPage == "verify"
                ? $t("payPsd.enterPayPsd")
                : $t("payPsd.enterOldPayPsd")
            }}
          </p>
          <p
            v-if="flag == 'edit' || parentPage == 'verify'"
            class="tips text-orange"
            @click="forgetPayPsd"
          >
            {{ $t("payPsd.forgotPayPsd") }}?
          </p>
          <div class="button-wrap">
            <van-button
              block
              type="primary"
              :disabled="oldDisabled"
              :loading="btnLoading"
              @click="buttonFun"
            >
              {{
                parentPage == "verify"
                  ? $t("common.confirm")
                  : $t("common.nextStep")
              }}
            </van-button>
          </div>
        </template>
        <template v-if="newFlag">
          <van-password-input
            :gutter="10"
            :value="newPsd"
            :focused="true"
            @focus="showKeyboard = true"
          />
          <p class="tips text-gray">
            {{ $t("payPsd.SetPayPsdTips") }}
          </p>
          <div class="button-wrap">
            <van-button
              block
              type="primary"
              :disabled="newDisabled"
              :loading="btnLoading"
              @click="buttonFun"
            >
              {{ $t("common.nextStep") }}
            </van-button>
          </div>
        </template>
        <template v-if="confirmFlag">
          <van-password-input
            :gutter="10"
            :value="confirmPsd"
            :focused="true"
            @focus="showKeyboard = true"
          />
          <p class="tips text-gray">
            {{ $t("payPsd.ConfirmPayPsdTips") }}
          </p>
          <div class="button-wrap">
            <van-button
              block
              type="primary"
              :disabled="confirmDisabled"
              :loading="btnLoading"
              @click="buttonFun"
            >
              {{ $t("common.confirm") }}
            </van-button>
          </div>
        </template>
        <!-- 数字键盘 -->
        <van-number-keyboard
          :show="true"
          @input="onInput"
          @delete="onDelete"
          @blur="showKeyboard = false"
        />
      </template>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import * as validate from "@/commonJs/validate.js";
export default {
  props: ["parentPage", "payPsdFlag"], //parentPage 来源页面、payPsdFlag 调用页面Flag
  name: "payPsd",
  meta: {
    power: false,
    service: false // 客服
  },
  components: {},
  data() {
    return {
      flag: "", //路由传参
      routeData: {}, //路由数据
      title: "",
      oldPsd: "",
      newPsd: "",
      confirmPsd: "",

      oldFlag: false, // 旧密码
      newFlag: true, // 新密码
      confirmFlag: false, // 确认密码
      oldDisabled: true, // 旧密码disabled
      newDisabled: true, // 新密码disabled
      confirmDisabled: true, // 确认密码disabled

      error: "",
      showKeyboard: true, // 键盘
      btnLoading: false // 按钮Flag
    };
  },
  created() {
    this.initialize();
  },
  mounted() {},
  computed: {},
  methods: {
    navBarBack() {
      // 返回事件
      if (this.payPsdFlag) {
        this.$emit("update:payPsdFlag", false);
      } else {
        this._back();
      }
    },
    initialize() {
      // 页面初始化
      let vm = this;
      vm.flag = vm.$route.query.flag;
      if (vm.flag == "reg" || vm.flag == "forget") {
        // 注册
        if (_.isEmpty(vm.$route.params)) {
          // 刷新页面要返回
          vm._back();
        } else {
          vm.routeData = vm.$route.params;
        }
        console.log("routeData", vm.routeData);
      }
      if (vm.flag == "reg" || vm.flag == "set" || vm.flag == "forget") {
        // 设置
        vm.oldFlag = false;
        vm.newFlag = true;
      }
      if (vm.flag == "set" || vm.flag == "forget") {
        vm.title = vm.$t("payPsd.SetPayPsd");
      }
      if (vm.flag == "edit") {
        vm.title = vm.$t("payPsd.modifyPayPsd");
        vm.oldFlag = true;
        vm.newFlag = false;
      }
      if (vm.parentPage == "verify") {
        vm.title = vm.$t("payPsd.VerifyPayPsd");
        vm.oldFlag = true;
        vm.newFlag = false;
      }
    },
    forgetPayPsd() {
      // 忘记支付密码
      this.$router.replace({
        path: "/forgetPayPsd"
      });
    },
    verifyPayPsd(data) {
      // 验证支付密码
      this.error = validate.validatePayPsd(data);
    },
    onInput(key) {
      // 监听按键输入
      let vm = this;
      if (vm.oldFlag) {
        vm.oldPsd = (vm.oldPsd + key).slice(0, 6);
      }
      if (vm.newFlag) {
        vm.newPsd = (vm.newPsd + key).slice(0, 6);
      }
      if (vm.confirmFlag) {
        vm.confirmPsd = (vm.confirmPsd + key).slice(0, 6);
      }
    },
    onDelete() {
      // 删除
      let vm = this;
      if (vm.oldFlag) {
        vm.oldPsd = vm.oldPsd.slice(0, vm.oldPsd.length - 1);
      }
      if (vm.newFlag) {
        vm.newPsd = vm.newPsd.slice(0, vm.newPsd.length - 1);
      }
      if (vm.confirmFlag) {
        vm.confirmPsd = vm.confirmPsd.slice(0, vm.confirmPsd.length - 1);
      }
    },
    buttonFun() {
      let vm = this;
      if (vm.oldFlag) {
        // 旧密码
        vm.verifyPayPsd(vm.oldPsd);
        if (vm.error) {
          vm.$toast(vm.error);
          return false;
        }
        if (vm.oldPsd.length == 6) {
          vm.validatePayPassword();
        }
        return false;
      }
      if (vm.newFlag) {
        // 新密码
        vm.verifyPayPsd(vm.newPsd);
        if (vm.error) {
          vm.$toast(vm.error);
          return false;
        }
        if (vm.newPsd.length == 6) {
          vm.oldFlag = false;
          vm.newFlag = false;
          vm.confirmFlag = true;
        }
        return false;
      }
      if (vm.confirmFlag) {
        // 确认密码
        vm.verifyPayPsd(vm.confirmPsd);
        if (vm.error) {
          vm.$toast(vm.error);
          return false;
        }
        if (vm.confirmPsd.length == 6 && vm.confirmPsd != vm.newPsd) {
          vm.$toast(vm.$t("common.twoPsdInconformity"));
          vm.oldFlag = false;
          vm.newFlag = true;
          vm.confirmFlag = false;
          vm.newPsd = "";
          vm.confirmPsd = "";
          return false;
        }
        if (vm.confirmPsd == vm.newPsd) {
          if (vm.flag == "reg") {
            // 注册
            vm.register();
          } else if (vm.flag == "edit" || vm.flag == "set") {
            // 编辑设置
            vm.userPayPassword();
          } else if (vm.flag == "forget") {
            // 忘记支付密码
            vm.forgetPayPwd();
          }
        }
      }
    },
    validatePayPassword() {
      // 验证支付密码
      let vm = this;
      vm.btnLoading = true;
      vm.$post(
        "/app/user/validatePayPassword",
        { pay_password: vm.oldPsd },
        { alert: true }
      ).then(res => {
        console.log("validatePayPassword", res);
        vm.btnLoading = false;
        if (res.code == 0) {
          if (vm.parentPage == "verify") {
            vm.$emit("getPayPsd", vm.oldPsd);
            vm.$emit("update:payPsdFlag", false);
          } else {
            vm.oldFlag = false;
            vm.newFlag = true;
            vm.confirmFlag = false;
          }
        } else {
          vm.$toast(res.msg);
        }
      });
    },
    userPayPassword() {
      // 更新支付密码
      let vm = this;
      let params = {};
      params.pay_password = vm.oldPsd;
      params.confirm_pay_password = vm.confirmPsd;
      vm.btnLoading = true;
      vm.$post("/app/user/userPayPassword", params, { alert: true }).then(
        res => {
          console.log("userPayPassword", res);
          vm.btnLoading = false;
          vm.$toast(res.msg);
          if (res.code == 0) {
            vm._back();
          }
        }
      );
    },
    forgetPayPwd() {
      let vm = this;
      let params = {};
      params.password = vm.routeData.password;
      params.phone = vm.routeData.phone;
      params.code = vm.routeData.code;
      params.pay_password = vm.newPsd;
      params.pay_password_again = vm.confirmPsd;
      vm.btnLoading = true;
      // /app/captcha/validateCode
      vm.$post("/app/user/forgetPayPwd", params, { loading: true }).then(
        res => {
          vm.btnLoading = false;
          console.log("forgetPayPwd", res);
          vm._back();
        }
      );
    },
    register() {
      // 注册
      let vm = this;
      let params = {};
      params.username = vm.routeData.username;
      params.password = vm.routeData.password;
      params.mark = vm.routeData.mark;
      params.nickname = vm.routeData.nickname;
      params.Invitees_id = vm.routeData.Invitees_id;
      params.phone = vm.routeData.phone;
      params.code = vm.routeData.code;
      params.pay_password = vm.confirmPsd;
      vm.btnLoading = true;
      vm.$post("/app/user/register", params, { alert: true }).then(res => {
        vm.btnLoading = false;
        console.log("register", res);
        if (res.code == 0) {
          vm.$toast(res.msg);
          localStorage.setItem("token", res.data.token);
          vm.$store.dispatch("SET_TOKEN", res.data.token);
          vm.$store.dispatch("GET_USER_INFO");
          // 首页
          vm.$router.push({
            path: "/home"
          });
        } else {
          vm.$toast(res.msg);
        }
      });
    }
  },
  watch: {
    oldPsd(num) {
      // 监听旧密码
      if (num.length == 6) {
        this.oldDisabled = false;
      } else {
        this.oldDisabled = true;
      }
    },
    newPsd(num) {
      // 监听新密码
      if (num.length == 6) {
        this.newDisabled = false;
      } else {
        this.newDisabled = true;
      }
    },
    confirmPsd(num) {
      // 监听确认密码
      if (num.length == 6) {
        this.confirmDisabled = false;
      } else {
        this.confirmDisabled = true;
      }
    }
  }
};
</script>

<style lang="less" scoped>
h3 {
  text-align: center;
  font-size: 24px;
  font-weight: 500;
  color: #4a4a4a;
}

/deep/.van-password-input {
  margin: 30px 50px 0;
  .van-hairline--surround::after,
  .van-hairline--left::after {
    border-width: 0;
    border-radius: 0;
  }
  ul li {
    border-bottom: 2px solid #4a4a4a;
  }
}

.tips {
  margin: 20px 50px;
  text-align: center;
}
.button-wrap {
  margin: 20px 40px;
}
</style>
